import React, { Component, useState } from 'react'; 
import { InputGroup, Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class DropdownComp extends Component {
    
    constructor(props) {
        super(props);
        this.state={
            selectedValue: "",
            key: props.keyObjName,
            value: props.valueObjName
        }
    } 
    render() {

        const handleSelect=(e)=>{
            console.log(e);
            this.setState({
                selectedValue : e
            })
        }

        const key = this.props.keyObjName
        const value = this.props.valueObjName
        // console.log("key", key, "value", value)

        return (
            <div className="App container">
              
              <DropdownButton
              variant="outline-dark"
              alignRight
              title={ this.props.selectedValue? this.props.selectedValue : "- Select -"}
              id="dropdown-menu-align-right"
              onSelect={this.props.actions}
                >{this.props.data.map((item) => {
                    return (
                        <Dropdown.Item eventKey={item[`${key}`]}>{item[`${value}`]}</Dropdown.Item>
                    )
                })}
              </DropdownButton>
            </div>
          );
    }
}

export default DropdownComp;


// ? Instructions to use
// ? --- 1. import component
// ? --- 2. place component -- <DropdownComp selectedValue={this.state.selectedFromDropdown} actions={handleSelect} data={dropdowndata} keyObjName={"SapId"} valueObjName={"SapName"}/> 
// ? --- 3. props :-
// ? selectedValue : pass a state to it to store key of selected value
// ? actions : pass a function here 
// ? data : pass data here
// ? keyObjName : pass key object name
// ? valueObjName : pass value object name